import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AdalService } from '../shared/adal.service';

@Component({
    selector: 'my-dashboard',
    template: require('./dashboard.component.html')
})
export class DashboardComponent {
    AppConfig: Object;    
    constructor(
        private router: Router,
        private adal: AdalService) {
        // Check Authentication
        if (!this.adal.getCachedToken()) {
           // this.router.navigate(["login"]);
        }
    }    
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/dashboard/dashboard.component.ts